var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pt-bill-receive',{staticClass:"pt-bill-receive__page"})
}
var staticRenderFns = []

export { render, staticRenderFns }